<template>
  <div>
    <span
      v-for="(daily, index) in dailyTimes"
      :key="index"
      class="d-inline-block"
      :class="getTimeClasses(daily, index) + ' ' + marginClass"
    >
      {{ daily.attendanceTime_HHmm }}
    </span>
    <div v-if="dailyTimes === null || dailyTimes.length === 0">
      --
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    dailyTimes: {
      type: Array,
      default: null
    },
    marginClass: {
      type: String,
      default: 'mx-2'
    }
    // attendance: {
    //   type: Object,
    //   default: null
    // }
  },
  methods: {
    // getTimeClasses: function (daily, index) {
    //   return [
    //     index % 2 === 1 ? 'pink--text text--darken-3' : 'blue--text text--darken-3',
    //     (daily.status === 'D' && daily.source === 'S') ? 'time-delete' : null,
    //     (daily.status === 'A' && daily.source === 'M') ? 'time-insert' : null
    //   ]
    // }
    getTimeClasses: function (daily, index) {
      let cs = ''
      if (index % 2 === 1) {
        cs = 'pink--text text--darken-3'
      } else {
        cs = 'blue--text text--darken-3'
      }
      if (daily.status === 'D' && daily.source === 'S') {
        cs += ' time-delete'
      }
      if (daily.status === 'A' && daily.source === 'M') {
        cs += ' time-insert'
      }
      return cs
    }
  }
}
</script>
